module.exports = __webpack_public_path__ + "img/gq.1f78740.svg";